module.exports = "/labor-cost/components/laborCostUsers-fd5455.html";